export default function Review() {
  return (
    <div className="review">
      <section>
        <div className="client-image-container" />
        <div className="client-review">
          <i className="fi fi-bs-quote-right"></i>
          <h3>
            <span>Warwick</span>'s talent and care for his work delivered
            excellent results on all aspects of our projects
          </h3>
          <h5>Aisha White - CEO Kt accessories</h5>
        </div>
      </section>
    </div>
  );
}
